import React from 'react';
import { Button, Card, DescriptionText, Header, OptionalText, TitleContainer } from './UploadMediaCard.styles';
import { Text15Regular } from '../../utils/Text/Text.styles';
import { ReactComponent as CheckIcon } from '../../../assets/icons/check-01.svg';

const UploadMediaCard = ({
  icon,
  title,
  description,
  uploadedMediaLength,
  minUploadMediaLength,
  buttonTitle,
  onButtonClick,
}) => {
  return (
    <Card>
      <Header>
        <TitleContainer>
          {icon}
          <Text15Regular>{title}</Text15Regular>
        </TitleContainer>
        {minUploadMediaLength ? (
          uploadedMediaLength < minUploadMediaLength ? null : (
            <CheckIcon stroke="#1672BA" />
          )
        ) : (
          <OptionalText>OPTIONAL</OptionalText>
        )}
      </Header>
      <DescriptionText>{description}</DescriptionText>
      <Button onClick={onButtonClick}>{buttonTitle}</Button>
    </Card>
  );
};

export default UploadMediaCard;
